/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { CommonUserProfileStore } from '@gh/common-shared';
import { EMPTY_ID } from '@gh/common-shared-data';
import { DEFAULT_LOCALE } from '@gh/config';

import { Locale } from '@gh/core-mls';
import { SupplierUserProfileDto, SupplierUserProfileRestService } from '@gh/supplier-shared-data';
import { Observable } from 'rxjs';
import { SupplierUserData } from './supplier-user-context';

function supplierUserDataFromDto(dto: SupplierUserProfileDto): SupplierUserData {
  return {
    backendBuildNumber: '',
    firstName: '',
    lastName: '',
    id: EMPTY_ID,
    locale: Locale.createFromStandard(DEFAULT_LOCALE),
    fullName: '',
    zoneId: '',
    login: dto.email,
    receiveEmails: dto.receiveEmails,
  };
}

@Injectable()
export class SupplierUserProfileStore extends CommonUserProfileStore<SupplierUserData> {

  constructor(private userProfileRest: SupplierUserProfileRestService) {
    super();
  }

  load(params: Hash<any>): void {
    this.userProfileRest.get()
      .subscribe(
        (user) => this.setLoggedInUser(supplierUserDataFromDto(user)),
        (error) => this.setLoginError(error),
      );
  }

  logout(): void {
    this.userProfileRest.logout()
      .subscribe(() => this.setLoggedOut());
  }

  updateLocale(locale: Locale): Observable<any> {
    throw new Error('Customer Portal does not support changing of locale');
  }

  updateReceiveEmails(receiveEmails: boolean): void {
    this.userProfileRest.update({ receiveEmails })
      .subscribe(
        (user) => this.setLoggedInUser(supplierUserDataFromDto(user)),
      );
  }
}
